import declare from "dojo/_base/declare";
import NewTestRun from "./NewTestRun";

const NewTestRunTemplate = declare(NewTestRun, {
	/**
	 * @override
	 * Allow Save & Go since you can only create one template at a time
	 */
	_canNavigate() {
		return true;
	},
});

export = NewTestRunTemplate;
